import * as React from 'react';

import { cn, Typography } from '@kiiwi/ui';
import { Dayjs } from 'dayjs';

type ProCardAvailabilitiesTimeSlotProps = {
  slot?: Dayjs;
  hasSubstitute: boolean;
  onTimeSlotClick: (event: React.MouseEvent) => void;
};

const ProCardAvailabilitiesTimeSlot = ({
  slot,
  hasSubstitute,
  onTimeSlotClick,
}: ProCardAvailabilitiesTimeSlotProps) => {
  return (
    <div
      className={cn(
        'w-19 relative flex h-8 items-center justify-center rounded-2xl ',
        slot
          ? 'cursor-pointer bg-brand-tonal-enabled'
          : 'pointer-events-none bg-brand-tonal-disabled',
      )}
      onClick={slot ? onTimeSlotClick : undefined}
    >
      <Typography
        variant="body-2"
        className={cn('font-semibold', !slot && 'text-neutral-disabled')}
      >
        {slot ? slot.format('HH:mm') : '-'}
      </Typography>

      {hasSubstitute && (
        <div className="absolute right-0 top-0 size-2 rounded-full bg-macro-primary-enabled" />
      )}
    </div>
  );
};

export default ProCardAvailabilitiesTimeSlot;
